import { DesktopHeader } from 'components/Layout/Header/DesktopHeader';
import { UserActions } from 'components/Layout/Header/UserActions';
import { LinkedLogotype } from 'components/Logotype/LinkedLogotype';
import CountryPicker from 'components/CountryPicker';
import useUser from 'stores/useCustomer';
import { DesktopWordpressMenu } from './DesktopWordpressMenu/DesktopWordpressMenu';
import { ConsultantWebshopProfile } from './ConsultantWebshopProfile';

export function WebshopDesktopHeader() {
    const isLoggedIn = useUser((state) => state.useLoggedIn());

    return (
        <DesktopHeader
            leftNode={<ConsultantWebshopProfile />}
            rightNode={(
                <span>
                    {!isLoggedIn && <CountryPicker />}
                    <UserActions />
                </span>
            )}
            centerNode={(
                <LinkedLogotype
                    linkProps={{
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            '& img': {
                                width: 268,
                                height: 38,
                            },
                        },
                    }}
                />
            )}
        >
            <DesktopWordpressMenu />
        </DesktopHeader>
    );
}
